import Head from "next/head";
import ExpectedUnexpectednessTablesPage from "../../../../src/tables/s14/ExpectedUnexpectednessTables.tsx";

export default function ExpectedUnexpectednessTablesRoute({ tables }) {
  return (
    <>
      <Head>
        <title>TFT Set 14 Expected Unexpectedness Tables</title>
      </Head>
      <ExpectedUnexpectednessTablesPage tables={tables} />
    </>
  );
}

export async function getStaticProps() {
  const tablesResp = await fetch(
    `https://ap.tft.tools/static/s14/hacked_egg.json`,
  );
  const tables = await tablesResp.json();

  return {
    props: {
      tables,
    },
    revalidate: 3600,
  };
}
